import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";
import PendingApproval from "@/pages/PendingApproval";
import BlockedAccount from "@/pages/BlockedAccount";
import type { UserRole } from "@/lib/auth/models/auth.model";

interface ApprovalRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
}

const ApprovalRoute = ({ children, allowedRoles }: ApprovalRouteProps) => {
  const { user, userStatus, userRole, loading } = useAuth()

  if (loading) {
    return <></>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Password non ancora impostata — qualsiasi ruolo
  if (userStatus === 'invited') {
    return <Navigate to="/set-password" replace />;
  }

  // Reset password richiesto: l'utente deve completare il cambio password
  if (userStatus === 'reset-psw') {
    return <Navigate to="/set-password" replace />;
  }

  // Account bloccato da un amministratore
  if (userStatus === 'blocked') {
    return <BlockedAccount />;
  }

  // In attesa di approvazione o accesso negato
  if (userStatus === 'pending' || userStatus === 'rejected') {
    return <PendingApproval />;
  }

  // approved — accesso concesso
  if (allowedRoles && userRole && !allowedRoles.includes(userRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ApprovalRoute; 